import { PermissionSetType, SuperAdminTestRolePermissionSet } from '../sets'

/**
 * Super admin roles are defined as a set so that we can modify their permissions in one place
 * Do not add a singular permission here, add it to the permission set defined here
 */
// This role is used for E2E testing purposes only, specifically just for
// creating and tearing down test orgs. It should not be used in production.
// This role should always have the bare minium permissions required to fulfill
// E2E testing needs.
export const TestSuperAdminRole: PermissionSetType[] = [SuperAdminTestRolePermissionSet.SuperAdminTestRole]
